import { useEffect, useState } from "react";

import { deleteIdeasMany as deleteContradictionsSolvings } from "../../../api/contradictionsSolvings";
import { deleteIdeasMany as deleteDetailsMatrix } from "../../../api/detailsMatrix";
import { deleteIdeasMany as deleteEurekas } from "../../../api/eureka";
import { deleteIdeasMany as deleteMultiplications } from "../../../api/multiplication";
import { deleteIdeasMany as deleteReplacements } from "../../../api/replacement";
import { deleteIdeasMany as deleteSubtractions } from "../../../api/subtractions";
import { restoreIdeas } from "../../../api/trash";

const getParams = (ideas) =>
  ideas.map((id) => ({
    issues: [],
    ideaId: id,
  }));

const getId = (ideas) => ideas.map((idea) => idea.id);

const initialState = {
  contradictionsSolvingsIds: [],
  detailsMatrixIds: [],
  eurekasIds: [],
  replacmentsIds: [],
  multiplicationsIds: [],
  subtractionsIds: [],
};

export const useTrashIdeas = (ideas) => {
  const [ideasPicked, setIdeasPicked] = useState(initialState);
  const [selectedAll, setSelectedAll] = useState(false);

  const handlePickedIdea = (idea) => {
    switch (idea.type) {
      case "contradictionSolving":
        setIdeasPicked({
          ...ideasPicked,
          contradictionsSolvingsIds: ideasPicked.contradictionsSolvingsIds.includes(idea.id)
            ? ideasPicked.contradictionsSolvingsIds.filter((id) => id !== idea.id)
            : [...ideasPicked.contradictionsSolvingsIds, idea.id],
        });
        break;
      case "eureka":
        setIdeasPicked({
          ...ideasPicked,
          eurekasIds: ideasPicked.eurekasIds.includes(idea.id)
            ? ideasPicked.eurekasIds.filter((id) => id !== idea.id)
            : [...ideasPicked.eurekasIds, idea.id],
        });
        break;
      case "replacement":
        setIdeasPicked({
          ...ideasPicked,
          replacmentsIds: ideasPicked.replacmentsIds.includes(idea.id)
            ? ideasPicked.replacmentsIds.filter((id) => id !== idea.id)
            : [...ideasPicked.replacmentsIds, idea.id],
        });
        break;
      case "multiplication":
        setIdeasPicked({
          ...ideasPicked,
          multiplicationsIds: ideasPicked.multiplicationsIds.includes(idea.id)
            ? ideasPicked.multiplicationsIds.filter((id) => id !== idea.id)
            : [...ideasPicked.multiplicationsIds, idea.id],
        });
        break;
      case "subtraction":
        setIdeasPicked({
          ...ideasPicked,
          subtractionsIds: ideasPicked.subtractionsIds.includes(idea.id)
            ? ideasPicked.subtractionsIds.filter((id) => id !== idea.id)
            : [...ideasPicked.subtractionsIds, idea.id],
        });
        break;
      case "dependency":
        setIdeasPicked({
          ...ideasPicked,
          detailsMatrixIds: ideasPicked.detailsMatrixIds.includes(idea.id)
            ? ideasPicked.detailsMatrixIds.filter((id) => id !== idea.id)
            : [...ideasPicked.detailsMatrixIds, idea.id],
        });
        break;
      default:
    }
  };

  const handlePickedIdeasAll = () => {
    if (
      ideasPicked.contradictionsSolvingsIds.length === ideas.contradictionSolving.length &&
      ideasPicked.detailsMatrixIds.length === ideas.detailsMatrix.length &&
      ideasPicked.eurekasIds.length === ideas.eureka.length &&
      ideasPicked.multiplicationsIds.length === ideas.multiplication.length &&
      ideasPicked.replacmentsIds.length === ideas.replacement.length &&
      ideasPicked.subtractionsIds.length === ideas.subtraction.length
    ) {
      setIdeasPicked(initialState);
    } else {
      setIdeasPicked({
        contradictionsSolvingsIds: getId(ideas.contradictionSolving),
        detailsMatrixIds: getId(ideas.detailsMatrix),
        eurekasIds: getId(ideas.eureka),
        replacmentsIds: getId(ideas.replacement),
        multiplicationsIds: getId(ideas.multiplication),
        subtractionsIds: getId(ideas.subtraction),
      });
    }
  };

  const handleRestoreIdeas = async (onSuccess, onError) => {
    if (
      ideasPicked.contradictionsSolvingsIds.length ||
      ideasPicked.detailsMatrixIds.length ||
      ideasPicked.eurekasIds.length ||
      ideasPicked.replacmentsIds.length ||
      ideasPicked.multiplicationsIds.length ||
      ideasPicked.subtractionsIds.length
    ) {
      await restoreIdeas(ideasPicked, onSuccess, onError);
    }
    setIdeasPicked(initialState);
  };

  const handleDeleteIdeas = async () => {
    //EUREKA
    if (ideasPicked.eurekasIds.length) {
      const params = getParams(ideasPicked.eurekasIds);

      await deleteEurekas(params);
    }

    //CONTRADICTIONS SOLVING
    if (ideasPicked.contradictionsSolvingsIds.length) {
      const params = getParams(ideasPicked.contradictionsSolvingsIds);

      await deleteContradictionsSolvings(params);
    }

    //MULTIPLICATION
    if (ideasPicked.multiplicationsIds.length) {
      const params = getParams(ideasPicked.multiplicationsIds);

      await deleteMultiplications(params);
    }

    //DETAILS MATRIX
    if (ideasPicked.detailsMatrixIds.length) {
      const params = getParams(ideasPicked.detailsMatrixIds);

      await deleteDetailsMatrix(params);
    }

    //SUBTRACTIONS
    if (ideasPicked.subtractionsIds.length) {
      const params = getParams(ideasPicked.subtractionsIds);

      await deleteSubtractions(params);
    }

    //REPLACEMENT
    if (ideasPicked.replacmentsIds.length) {
      const params = getParams(ideasPicked.replacmentsIds);

      await deleteReplacements(params);
    }

    setIdeasPicked(initialState);

    setSelectedAll(false);
  };

  // TODO: refactor this logic and remove useEffect
  useEffect(() => {
    if (
      ideasPicked.contradictionsSolvingsIds?.length === ideas.contradictionSolving?.length &&
      ideasPicked.detailsMatrixIds?.length === ideas.detailsMatrix?.length &&
      ideasPicked.eurekasIds?.length === ideas.eureka?.length &&
      ideasPicked.multiplicationsIds?.length === ideas.multiplication?.length &&
      ideasPicked.replacmentsIds?.length === ideas.replacement?.length &&
      ideasPicked.subtractionsIds?.length === ideas.subtraction?.length &&
      (ideas.contradictionSolving?.length > 0 ||
        ideas.detailsMatrix?.length > 0 ||
        ideas.eureka?.length > 0 ||
        ideas.multiplication?.length > 0 ||
        ideas.replacement?.length > 0 ||
        ideas.subtraction?.length > 0)
    ) {
      setSelectedAll(true);
    } else {
      setSelectedAll(false);
    }
  }, [ideasPicked]);

  return {
    ideasPicked,
    selectedAll,

    handlePickedIdea,
    handlePickedIdeasAll,
    handleRestoreIdeas,
    handleDeleteIdeas,
  };
};
